/**
 * Превью игр для hero-коллажа — берутся ЛОКАЛЬНО, не с бэкенда.
 *
 * Раньше Hero тянул фид Storys (getFeed/getTrending) — каждый ответ нёс
 * 24-30 thumbnail'ов base64 (~10 КБ каждый = ~300 КБ JSON), коллаж долго
 * грузился. Теперь превью сохранены в public/games-preview/ как обычные
 * jpg-файлы + manifest.json — браузер кеширует их, грузятся мгновенно.
 *
 * Обновить набор: запустить скачивание превью заново (см. INFO_PROCESS.md
 * 2026-05-15) — оно перезапишет public/games-preview/.
 *
 * Манифест грузится один раз через fetch локального файла (быстро, кешируется).
 */

const MANIFEST_URL = process.env.PUBLIC_URL + "/games-preview/manifest.json";
const PREVIEW_BASE = process.env.PUBLIC_URL + "/games-preview/";

/**
 * Возвращает массив игр для коллажа: [{id, title, author, thumbnail, ...}].
 * thumbnail — путь к локальному jpg (не base64, не запрос к API).
 */
export async function getHeroGames(signal) {
  const res = await fetch(MANIFEST_URL, { signal });
  if (!res.ok) throw new Error("manifest not found");
  const manifest = await res.json();
  return manifest.map((g) => ({
    id: g.id,
    title: g.title,
    author: g.author,
    thumbnail: PREVIEW_BASE + g.file,
    play_count: g.play_count,
    likes_count: g.likes_count,
    genre: g.genre,
  }));
}
